import { render, staticRenderFns } from "./OrderRoutes.vue?vue&type=template&id=f4d41f52&"
import script from "./OrderRoutes.vue?vue&type=script&lang=js&"
export * from "./OrderRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports